import { render, staticRenderFns } from "./DimensionInputs.vue?vue&type=template&id=dd9006ce&"
import script from "./DimensionInputs.vue?vue&type=script&lang=ts&"
export * from "./DimensionInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports